import {useEffect} from "react";
import {useSignal} from "@preact/signals-react";
import {postSubmit} from "@ui-seeker/utils";

import { WEBBACK_V2_API } from "@constants";
import { isLoadingCommonFilters, isSystemBusy } from "@signals";
import { elementsInLoading, stockAssDetailsSummaryFilters } from "../@signals";


/**
 * The summary widgets for several splits in **one** request.
 *
 * The legacy `/details/widgets` answers a single `splitKpi` per call, so this screen used to
 * issue three (market / retailer / brand) that repeated the same ~2s of queries and only
 * differed in the final grouping. `/details/widgets-multi` (v2 only) answers all of them at
 * once, keyed by split.
 *
 * @param splitKpi splits to ask for, e.g. `[GROUPED_BY.COUNTRY, GROUPED_BY.RETAILER]`
 * @returns `{ data, isLoading }`, where `data` is `{ [split]: rows }`
 */
export default function useStockAssDetailsSummary(splitKpi) {

    const data = useSignal({})
    const isLoading = useSignal(false)

    useEffect(() => {
        if (isLoadingCommonFilters.value) {
            data.value = {}
            isLoading.value = true
            postSubmit(`${WEBBACK_V2_API}/stock-assortment/details/widgets-multi`, {
                ...stockAssDetailsSummaryFilters.value,
                splitKpi
            }).then(res => {
                data.value = res
                isLoading.value = false
            })
            .catch(() => {
                isLoading.value = false
                isSystemBusy.value = true
            })
        }
    }, [isLoadingCommonFilters.value])

    useEffect(() => {
        if (isLoading.value)
            elementsInLoading.value = [...elementsInLoading.value, 'summaryWidgets']
        else
            elementsInLoading.value = elementsInLoading.value.filter(item => item !== 'summaryWidgets')
    }, [isLoading.value])

    return {
        data: data.value,
        isLoading: isLoading.value
    }
}
